import { IGetJobPostDetailResult } from '../types';
import { JobPostAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { GetJobPostingInsufficientAccessError } from '../errors';

export const getJobPostDetail = async (id: string): Promise<IGetJobPostDetailResult> => {
  try {
    const response = await PermanentJobsApi.getJobPostDetail(id);

    return JobPostAdapters.toGetJobPostDetailResult(response);
  } catch (error) {
    const errInsufficientAccess = GetJobPostingInsufficientAccessError.fromAxiosError(error);

    if (errInsufficientAccess) {
      throw errInsufficientAccess;
    }

    throw error;
  }
};
